// extracted by mini-css-extract-plugin
export var button = "ButtonSecondary-module--button--FPb7S";
export var text = "ButtonSecondary-module--text--GpRDq";